import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Eye, EyeOff, Save } from "lucide-react";
import { Btn, FieldRow, Section, inputCls } from "@/components/account/Shell";
import api, { formatApiError } from "@/lib/api";

/** The private locker drop-off code — never on a public endpoint, shown only after a paid order. */
export default function DropoffCode() {
    const [code, setCode] = useState("");
    const [show, setShow] = useState(false);
    const [busy, setBusy] = useState(false);
    useEffect(() => {
        api.get("/admin/settings").then(({ data }) => setCode(data.dropoff_code || "")).catch(() => { });
    }, []);
    const save = async () => {
        setBusy(true);
        try {
            await api.put("/admin/settings", { dropoff_code: code.trim() });
            toast.success("Drop-off code saved");
        } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
    };
    return (
        <Section title="Locker drop-off code" testid="dropoff-code-panel" pad={false}
            note="private · customers see it only on a paid order that includes their own apparel · change it here after you change it on the locker">
            <FieldRow label="Drop-off code" testid="dropoff-code-row">
                <div className="flex items-center gap-2">
                    <input className={`${inputCls} max-w-[200px]`} type={show ? "text" : "password"} value={code} autoComplete="off"
                        onChange={(e) => setCode(e.target.value)} data-testid="dropoff-code-input" />
                    <Btn onClick={() => setShow((v) => !v)} testid="dropoff-code-toggle">
                        {show ? <EyeOff size={11} /> : <Eye size={11} />} {show ? "hide" : "show"}
                    </Btn>
                    <Btn onClick={save} disabled={busy} tone="solid" testid="dropoff-code-save"><Save size={11} /> save</Btn>
                </div>
            </FieldRow>
        </Section>
    );
}
